// @flow
import Raven from 'raven-js'

const staging = 'https://f2b7bd2add5c44e99edaf594068a137a@sentry.io/244226'
const production = 'https://aaec8ae530694b20884f279b89771064@sentry.io/244271'

const environment = process.env.NODE_ENV || 'development'

const ravenDSN = environment === 'development' ? staging : production

// Raven extra configuration
// https://docs.sentry.io/clients/javascript/config/
const options = {
  environment,
  ignoreUrls: [
    /dco\.smartclip\.net/,
    /pixel\.adsafeprotected\.com/,
    /moz-extension:\/\//,
  ],
}

const initRaven = () => Raven.config(ravenDSN, options).install()

export default initRaven



// WEBPACK FOOTER //
// ./src/sentryConfig.js